import React from 'react';

const AvisoPrivacidadForm = () => (
  <p className="form-text mt-2 mb-0">
    Al enviar este formulario, aceptas nuestro{' '}
    <a href="/aviso-de-privacidad">Aviso de Privacidad</a>.
  </p>
);

export default AvisoPrivacidadForm;
